import { useQuery } from "react-query";
import { useXeroClient } from "../hooks";

export const useAccounts = (config) => {
  const xero = useXeroClient();

  return useQuery({
    queryKey: "accounts",
    queryFn: () => xero.get("accounts").get("data"),
    ...(config ?? {}),
  });
};
